<script setup lang="ts">
import { cn } from '~/shared/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

const badgeVariants = cva(
    'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
                secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
                destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
                outline: 'text-foreground',
                success: 'border-transparent bg-green-100 text-green-800',
                warning: 'border-transparent bg-yellow-100 text-yellow-800',
            }
        },
        defaultVariants: {
            variant: 'default'
        }
    }
)

interface Props {
    variant?: VariantProps<typeof badgeVariants>['variant']
    class?: string
}

const props = withDefaults(defineProps<Props>(), {
    variant: 'default',
    class: ''
})
</script>

<template>
    <div :class="cn(badgeVariants({ variant: props.variant }), props.class)">
        <slot />
    </div>
</template> 